import _typeof2 from 'babel-runtime/helpers/typeof';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import ExecutionResult from '../container/execution-result';
import Result from '../../_interface/result';
export var UpModule = function () {
    function UpModule(plugin) {
        _classCallCheck(this, UpModule);

        if (plugin === null || plugin === undefined) {
            throw Error(this['typeof']() + '\u63D2\u4EF6\u5B9E\u4F8B\u4E3A\u7A7A!!!');
        }
        this.plugin = plugin;
    }

    _createClass(UpModule, [{
        key: 'getErrorCodeAndText',
        value: function getErrorCodeAndText(_code) {
            return { msg: '默认调用失败', code: '000001' };
        }
    }, {
        key: 'generatePromiseByPluginFunctionWithParams',
        value: function generatePromiseByPluginFunctionWithParams(func) {
            var _this = this;

            for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                params[_key - 1] = arguments[_key];
            }

            var self = this;
            document.container.upLogModule.printParameters(func, params);
            return new Promise(function (resolve, reject) {
                var _self$plugin;

                self.rejectIfNoPlugin(reject, func);
                // @ts-ignore
                (_self$plugin = self.plugin)[func].apply(_self$plugin, params.concat([function (result) {
                    if (result.isSuccessful()) {
                        document.container.upLogModule.printSucceedResult(func, result);
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570' + func + '(' + params.join(',') + ')\u6210\u529F', result.retData));
                    } else {
                        document.container.upLogModule.printFailResult(func, result);
                        reject(_this.handleErrorCodeToResult(func, params, result));
                    }
                }]));
            });
        }
    }, {
        key: 'rejectIfNoPlugin',
        value: function rejectIfNoPlugin(reject, func) {
            if (!this.plugin) {
                var result = new ExecutionResult('990001', this['typeof']() + '\u6A21\u5757\u672A\u5B9A\u4E49');
                document.container.upLogModule.printFailResult(func, result);
                reject(result);
            }
        }
    }, {
        key: 'generatePromiseByPluginFunctionWithNotPrint',
        value: function generatePromiseByPluginFunctionWithNotPrint(func) {
            var _this2 = this;

            for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                params[_key2 - 1] = arguments[_key2];
            }

            var self = this;
            // document.container.upLogModule.printParameters(func, params);
            return new Promise(function (resolve, reject) {
                var _self$plugin2;

                self.rejectIfNoPlugin(reject, func);
                // @ts-ignore
                (_self$plugin2 = self.plugin)[func].apply(_self$plugin2, params.concat([function (result) {
                    if (result.isSuccessful()) {
                        // document.container.upLogModule.printSucceedResult(func, result);
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570' + func + '(' + params.join(',') + ')\u6210\u529F', result.retData));
                    } else {
                        // document.container.upLogModule.printFailResult(func, result);
                        reject(_this2.handleErrorCodeToResult(func, params, result));
                    }
                }]));
            });
        }
    }, {
        key: 'handleErrorCodeToResult',
        value: function handleErrorCodeToResult(func, params, result) {
            var errorInfo = this.getErrorCodeAndText(result.retCode);
            if (errorInfo.msg !== '默认调用失败' && (result === null || result === void 0 ? void 0 : result.retCode)) {
                return new Result(errorInfo.code, '\u8C03\u7528\u51FD\u6570' + func + '(' + params.join(',') + ')\u5931\u8D25,errMsg:' + errorInfo.msg, result.retData || '');
            }
            var retData = result.retData || '';
            if (retData === '') {
                retData = result.retCode || '';
            }
            return new Result('000001', '\u8C03\u7528\u51FD\u6570' + func + '(' + params.join(',') + ')\u5931\u8D25', retData);
        }
    }, {
        key: 'typeof',
        value: function _typeof() {
            return _typeof2(this.plugin);
        }
    }]);

    return UpModule;
}();